var chunkMapping = {
	"20": [
		20571
	],
	"377": [
		10377
	],
	"6662": [
		86662
	],
	"7299": [
		53788
	],
	"8776": [
		22948
	]
};
var idToExternalAndNameMapping = {
	"10377": [
		"default",
		"./purchase/category",
		2017
	],
	"20571": [
		"default",
		"./store-provider",
		2017
	],
	"22948": [
		"default",
		"./router",
		2017
	],
	"53788": [
		"default",
		"./app",
		2017
	],
	"86662": [
		"default",
		"./purchase/success",
		2017
	]
};
var idToRemoteMap = {
	"10377": [
		{
			"externalType": "script",
			"name": "lk",
			"externalModuleId": 2017
		}
	],
	"20571": [
		{
			"externalType": "script",
			"name": "lk",
			"externalModuleId": 2017
		}
	],
	"22948": [
		{
			"externalType": "script",
			"name": "lk",
			"externalModuleId": 2017
		}
	],
	"53788": [
		{
			"externalType": "script",
			"name": "lk",
			"externalModuleId": 2017
		}
	],
	"86662": [
		{
			"externalType": "script",
			"name": "lk",
			"externalModuleId": 2017
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}